module.exports = __webpack_public_path__ + "media/images/SAPC5456-3f1f58d820b11c7f1b6153d371f267ae.png";